import { createUseItem } from "../helpers/fetchHooks";
import createItemFetcher from "../helpers/item";
const computeConnectorsId = () => "focasConnectors";
const computeFocasConnectorsUrl = () => "/api/v1/aggregation-service/event-source";
const getFocasConnectors = createItemFetcher(computeFocasConnectorsUrl, "FOCAS_CONNECTORS_GET", computeConnectorsId);
export const useFetchFocasConnectors = createUseItem(getFocasConnectors, (state) => state.focasConnectors.connectors);
export function createFocasConnectorsActions() {
    const computeGetFocasConnectorUrl = (eventSource) => `/api/v1/aggregation-service/event-source/${eventSource}`;
    const getFocasConnector = createItemFetcher(computeGetFocasConnectorUrl, "FOCAS_CONNECTOR_GET", computeConnectorsId);
    return {
        connectors: getFocasConnectors,
        connector: getFocasConnector,
    };
}
//# sourceMappingURL=focasConnectorsActions.js.map